import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {NavService} from '../../../../_services/_nav.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ParametriaService} from '../../../../_services/parametria.service';
import {Parametria} from '../../../../_models/parametrias';
import {SolicitudService} from '../../../../_services/solicitud.service';
import {forkJoin, Subscription} from 'rxjs';
import {Table} from 'primeng/table';
import {BotonesSolicitud, CanalComunicacion} from '../../../../_enums/enum';
import {ComunicationComponentsService} from '../../../../_services/comunication-components.service';
import {ConfirmationService} from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { RxStompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { ExcelAvance } from '../../../../_models/excel-avance';
import { UtilitiesService } from '../../../../utils/utilities.service';
import { AutenticacionService } from '../../../../_services/autenticacion.service';
import {LocalizacionesComponent} from '../../../localizaciones/localizaciones.component';
import {CambioEstadosComponent} from '../../../cambio-estados/cambio-estados.component';
import {SolicitudEstadoHistoricoService} from '../../../../_services/solicitud-estado-historico.service';
import {CreditoService} from '../../../../_services/credito.service';
import {Credito} from '../../../../_models/credito';
import {SolicitudTasaEspecialService} from '../../../../_services/solicitud-tasa-especial.service';

@Component({
  selector: 'app-widget-integraciones-shivam',
  templateUrl: './widget-integraciones-shivam.component.html',
  styleUrls: ['./widget-integraciones-shivam.component.css']
})
export class WidgetIntegracionesShivamComponent implements OnInit, OnDestroy {
  loading = true;
  solicitudes: any[] = [];
  columnas: any[] = [];
  showModalSolicitudes = false;
  showModalCausal: false;
  parametria: Parametria;
  contador: number;
  //Variables del datatable
  public numeroRegistros: number;
  loadingTable = false;
  //Paginacion
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;
  @ViewChild('dt') tabla: Table;
  filtroLazy: {
    cantidad: number,
    pagina: number
  };
  listSolicitudes: any[] = [];
  botonesSolicitud = BotonesSolicitud;
  subscription: Subscription;
  cambioEstado = { mosModal: false, guardando: false, submitted: false, lisCausales: [] as SelectItem[], mosModalProceso: false };
  formulario: FormGroup;
  private topSubscription: Subscription;
  excelAvance: ExcelAvance;
  lanIntegracion = false;
  modalVerificacion = {verificando: false, estActual: null, error: false, individual: false};

  constructor(private navServicio: NavService,
              private parametriaService: ParametriaService,
              private solicitudService: SolicitudService,
              private conServicio: ConfirmationService,
              private rxStompService: RxStompService,
              public utilitiesService: UtilitiesService,
              private authService: AutenticacionService,
              private diaService: DialogService,
              private solEstadoHistoricoService: SolicitudEstadoHistoricoService,
              private creditoService: CreditoService,
              private solicitudTasaEspecialService: SolicitudTasaEspecialService) { }

  ngOnInit() {
    this.contador = 0;
    this.columnas = [
      { field: 'tipoSolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_TIPOSOLICITUD' ), sort: true, check: false },
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NUMERODOCUMENTO' ), sort: true, check: false },
      { field: 'idSolicitudInterno', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_NUMEROSOLICITUD' ), sort: true, check: false },
      { field: 'fechasolicitud', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_FECHASOLICITUD' ), sort: true, check: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_METODO' ), sort: true, check: false },
      { field: 'error', header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_ERROR' ), sort: false, check: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false, check: false }
    ];

    window.onbeforeunload = () => this.ngOnDestroy();
    this.conectarSocket();

    forkJoin(this.cargarContador(), this.parametriaService.estadoShivan()).subscribe(([totalPendientesShivan, estadoIntegracionesShivan  ]) => {
      if (!estadoIntegracionesShivan) {
        this.parametria.indicadorEncendidoShivam = true;
        this.parametria.indicadorHabilitado = true;
        this.parametriaService.crear(this.parametria).subscribe(resCreate => {
          this.parametria = resCreate;
        }, error => {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'WIDGETS.LBL_MSGCONSULTAR' )
          } );
        });
      } else {
        this.parametria = estadoIntegracionesShivan;
      }

      this.loading = false;

    });

  }

  async revisarEncendidoShivam(): Promise<boolean> {
    const estadoIntegracionesShivan = await this.parametriaService.estadoShivan().toPromise();
    if (!estadoIntegracionesShivan) {
      return true;
    } else {
      return estadoIntegracionesShivan.indicadorEncendidoShivam;
    }
  }

  async cargarContador() {
    const pendientes = await this.solicitudService.contadorPendientesShivan().toPromise();
    this.contador = pendientes;
  }

  visualizarIntegracionesFallidas() {
    this.showModalSolicitudes = true;
    this.filter();
  }


  actualizarIntegrador() {
    if (this.parametria && this.parametria.indicadorEncendidoShivam) {
        this.parametria.indicadorEncendidoShivam = false;
    } else {
      this.parametria.indicadorEncendidoShivam = true;
    }
    this.parametriaService.actualizar(this.parametria).subscribe(response => {
      this.parametria = response;
    }, error => {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'WIDGETS.LBL_MSGACTUALIZAR' )
      } );
    });
  }

  async filter(event: any = null) {
      this.loadingTable = true;
      if ( event ) {
        this.page = String( event.first / this.rowsPerPage );
      } else {
        this.page = '0';
      }

      const a = Object.assign({}, this.filtroLazy);
      a.pagina = Number( this.page );
      a.cantidad = this.rowsPerPage;

      this.solicitudService.buscadorSolicitudesPendientesShivan(a).subscribe(listaSolicitudes => {
        this.numeroRegistros = Number( listaSolicitudes.total );
        this.listSolicitudes = [];

        this.listSolicitudes = listaSolicitudes.data;
        this.loadingTable = false;
        if (this.listSolicitudes.length === 0 ) {
          this.navServicio.setMesage( 0,
            {
              severity: 'info',
              summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'WIDGETMODAL.MSG_NOEXISTENREGISTROS' )
            } );
        }

      }, error => {
        this.loadingTable = false;
        this.navServicio.setMesage( 0,
          {
            severity: 'error',
            summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
            detail: this.navServicio.buscarMensaje( 'MSG_ERRORCARGAR' )
          } );
      });
  }


  modalConfirmacion( solicitud: any) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje("WIDGETMODAL.MSG_CANELARSOLICITUD"),
      header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
      icon: 'fa fa-question-circle',
      key: 'cambio-estado',
      accept: () => {
        this.verModal(solicitud);
      },
      reject: () => {
      }
    } );
  }

  verModal(solicitud) {
    const modal = this.diaService.open( CambioEstadosComponent, {
      header: this.navServicio.buscarMensaje( 'WIDGETMODAL.LBL_CANCELAR' ),
      width: '40%',
      closeOnEscape: false,
      closable: false,
      maskStyleClass: 'overflow-y-unset',
      data: {
        idSolicitud: solicitud.idSolicitud,
        idEstado: solicitud.idEstado,
        idProducto: solicitud.idProducto,
        idFase: solicitud.idFase,
        tipo: BotonesSolicitud.CANCELAR
      },
    } );
    modal.onClose.subscribe( ( res: any ) => {
      if (res) {
         this.filter();
      }
    } );
  }

  mostrarErrorEnModal(data: {[key:string]: any}, mensaje: string) {
    const simbolos = ['{', '}', '@', '"'];
    const contieneSimbolo = simbolos.some(simbolo => mensaje.includes(simbolo));

    const contienePunto = mensaje.includes('.') && mensaje[mensaje.length - 1] !== '.';

    const contieneNumero = /\d/.test(mensaje);

    const mismoErrorAnterior = mensaje === data.error;

    return contieneSimbolo || contienePunto || contieneNumero || mismoErrorAnterior;
  }

  async validaCausalWidget(data: any) {
    return new Promise( resolve => {
      console.log('idSolicitud: ' + data.idSolicitud);
      try {
        this.solEstadoHistoricoService.obtenerPorSolicitudUltimoEstado(data.idSolicitud).subscribe( solEH => {
          if ( solEH && solEH.idCausalSolicitud && solEH.codigoCausalSolicitud && solEH.codigoCausalSolicitud === 'ERRCRE' ) {
            // actualice el crédito
            try {
              this.creditoService.listadoPorSolicitud( data.idSolicitud).subscribe( async objCredito => {

                const tasaEspecial = await this.solicitudTasaEspecialService.listadoPorSolicitud( data.idSolicitud ).toPromise();
                const tasaEspecialSolicitada = tasaEspecial.find( f => f.codigoEstadoTasaSugerida === 'APRO' );

                objCredito.tasa = (tasaEspecialSolicitada && tasaEspecialSolicitada.codigoEstadoTasaSugerida === 'APRO') ?
                  tasaEspecialSolicitada.tasa : objCredito.tasa;

                try {
                  this.creditoService.actualizarCreditoYCreditoAprobaciones(objCredito).subscribe(credito => {
                    console.log('Crédito actualizado.');
                    resolve(true);
                  });
                } catch (e) {
                  resolve(false);
                }
              } )
            } catch (e) {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        } )
      } catch (e) {
        resolve(false);
      }
    } )
  }

  async enviarIntegracionIndividual(data: {[key:string]: any}) {
    const indicador = await this.revisarEncendidoShivam();
    if (!indicador) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_SHIVAMAPAGADO')
      } );
      return;
    }
    if ( this.lanIntegracion) {
      return;
    }

    // se encarga de validar que si solicitud cayó al widget por causal ERRCRE, entonces actualiza el crédito antes de enviar integración individual
    await this.validaCausalWidget(data).then( x => {
      this.lanIntegracion = true;
      this.modalVerificacion.estActual = 'INIT';
      this.modalVerificacion.verificando = true;
      this.modalVerificacion.individual = true;
      this.solicitudService.verificarIntegracionIndividual(data.idSolicitud).subscribe(res => {
        if (res.error && !this.mostrarErrorEnModal(data, res.mensaje)) {
          this.navServicio.setMesage(0, {
            severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
            detail: res.mensaje
          });
          if (!res.indicadorPendienteShivam) {
            this.listSolicitudes = this.listSolicitudes.filter(s => s.idSolicitud !== data.idSolicitud);
          }
          this.modalVerificacion.estActual = null;
          this.cerrarVerificacion(true);
        } else {
          this.modalVerificacion.estActual = 'FINVER';
          if (res.error) {
            this.excelAvance = {} as ExcelAvance;
            this.excelAvance.errores = [];
            this.excelAvance.errores.push(res.mensaje);
            this.modalVerificacion.error = true;
          } else {
            this.listSolicitudes = this.listSolicitudes.filter(s => s.idSolicitud !== data.idSolicitud);
          }
        }
        this.lanIntegracion = false;

      }, error => {
        this.modalVerificacion.verificando = false;
        this.modalVerificacion.estActual = null;
        this.modalVerificacion.individual = false;
        this.lanIntegracion = false;
        this.navServicio.setMesage(0, {
          severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
        });
      });
    } )
  }

  async enviarIntegraciones() {
    // Consumir servicio de verificacion de archivo
    const indicador = await this.revisarEncendidoShivam();
    if (!indicador) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_SHIVAMAPAGADO')
      } );
      return;
    }
    if ( this.lanIntegracion) {
      return;
    }
    this.lanIntegracion = true;
    this.solicitudService.verificarIntegracion().subscribe(data => {
      this.modalVerificacion.estActual = 'INIT';
      this.excelAvance = data;
      this.lanIntegracion = false;
      this.modalVerificacion.verificando = true;
    }, error => {
      this.navServicio.setMesage(0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES')
        });
      this.lanIntegracion = false;
    });
  }

  conectarSocket() {
    this.topSubscription = this.rxStompService.watch('/topic/pendienteShivam.' + this.authService.obtenerIdUsuarioLogueado()).subscribe(async (message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      console.log(body);
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
        }
      }
    });
  }

  async cerrarVerificacion(individual: boolean = false) {
    this.modalVerificacion.verificando = false;
    if (!individual) {
      this.showModalSolicitudes = false;
    } else {
      this.modalVerificacion.individual = false;
    }
    this.modalVerificacion.error = false;
    this.excelAvance = null;
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  ngOnDestroy() {
    if (this.topSubscription) {
      this.topSubscription.unsubscribe();
      if ( this.excelAvance && this.excelAvance.uid ) {
        this.solicitudService.cancelarLanzadoIntegracion(this.excelAvance.uid).subscribe();
      }
    }
  }

}
